import { render, staticRenderFns } from "./productReturn.vue?vue&type=template&id=1bc4f3b6&scoped=true&"
import script from "./productReturn.vue?vue&type=script&lang=js&"
export * from "./productReturn.vue?vue&type=script&lang=js&"
import style0 from "./productReturn.vue?vue&type=style&index=0&id=1bc4f3b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc4f3b6",
  null
  
)

export default component.exports